
<div class="filter-btns-container">
  {{ uniqueTedDomains().length }} TED {{ uniqueTedDomains().length === 1 ? 'Domain' : 'Domains' }}
</div>

<section [ngClass]="{ 'scrollable-body': tedDomainData().length > 10, 'non-scrollable-body': tedDomainData().length <= 10 }">
  @for(ted of uniqueTedDomains(); track ted; let i = $index;) {
  <div class="card domain-card" (click)="onCardClick(ted)" [class.selected-card]="selectedRowCard()?.tedNumber === ted.tedNumber">
    <p class="card-title">
      <span style="display: block"><strong>Domain {{ted.tedNumber}}</strong></span>
    </p>
    <p  *ngIf="ted.label !== '-'" class="card-chain">CATH:
      {{ ted.label }} 
    </p>
    <p  *ngIf="ted.label === '-'" class="card-chain">CATH:
      No match
    </p>
  </div>
  } 
</section>
    